export const DEFAULT_USER = {
  _id: null,
  firstName: '',
  lastName: '',
  orgId: '',
  org: null,
  aiActors: [],
  accessRoles: [],
  email: '',
  picture: '',
  phone: '',
  workPhone: '',
  department: '',
  jobTitle: '',
  createdAt: undefined,
  updatedAt: undefined
};

export const NONE_ORG_OPTION = { _id: '', name: 'None', org_id: '_null' };

export const DEFAULT_PROFILE_COLORS = [
  '#00887A',
  '#BF360C',
  '#0098A6',
  '#F5511E',
  '#EF6C00',
  '#512DA7',
  '#5C6BC0',
  '#C2175B',
  '#465A65',
  '#33691E',
  '#78909C',
  '#689F39',
  '#004C3F',
  '#5D4038'
];
